export enum BaseCustomerCompanySettingsEnum {
  ASSIGNMENTS_LOCATION_ONLY = 'assignmentsLocationOnly',
  EP_LOCATION_ONLY = 'equalPayLocationOnly',
  RATINGS_LOCATION_ONLY = 'ratingsLocationOnly',
}
